import styled from 'styled-components'
import Icon from './Icon'

const GlobeIcon = styled(Icon).attrs({
  type: 'globe',
})``

export default GlobeIcon
